<template>

    <div class="ml-4">

        <Link :href="route('language', [selectable_locale])"
            class="flex items-center justify-end">

            <p class="text-xl font-nexa text-blue mr-4 mt-1">{{ selectable_text }}</p>

            <LanguageIcon class="w-5 h-5 rounded-full" :name="selectable_locale" />

        </link>

    </div>

</template>

<script>


import Link from "./Link";
import LanguageIcon from "./LanguageIcon";

export default {

    name: "LanguageSelector",

    components: {
        LanguageIcon,
        Link
    },

    computed: {
        selectable_locale() {

            if ( this.$page.props.locale === 'da' ) {

                return 'en';

            }

            return 'da';

        },

        selectable_text() {

            return {
                en: 'English',
                da: 'Dansk'
            }[ this.selectable_locale ];

        }
    },
}

</script>

<style scoped>

</style>
